import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
  barThin: {
    width: "100%",
    height: ({ height }) => (height ? height : theme.spacing(1)),
    boxShadow: "inset 2px 4px 10px rgba(0, 0, 0, 0.08)",
    "&:after": {
      content: "''"
    }
  },
  barThick: {
    width: "100%",
    height: theme.spacing(3)
  },
  segmented: {
    height: 14,
    borderRadius: 2.5,
    "&:after": {
      width: "100%",
      content: "''",
      height: "100%",
      background:
        "repeating-linear-gradient( 90deg, transparent, transparent 18px, #fff 10px, #fff 20px )",
      position: "absolute"
    }
  }
}));

export default function ProgressBar(props) {
  const { completedSteps, totalSteps, height } = props;
  const classes = useStyles({ height });
  return (
    <LinearProgress
      className={clsx({
        [classes.segmented]: props.segmented
      })}
      classes={{
        root: `${props.thick ? classes.barThick : classes.barThin}`
      }}
      color={props.color}
      variant="determinate"
      value={totalSteps === 0 ? 0 : (completedSteps / totalSteps) * 100}
    />
  );
}

ProgressBar.propTypes = {
  color: PropTypes.string,
  thick: PropTypes.bool,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
  segmented: PropTypes.bool
};
